export enum ComponentSize {
    XS = "xs",
    SM = "sm",
    MD = "md",
    LG = "lg",
    XL = "xl",
}

export enum LabelPlacement {
    Before = "before",
    After = "after",
    Inside = "inside",
}

export enum ComponentColor {
    Default = "default",
    Neutral = "neutral",
    Primary = "primary",
    Secondary = "secondary",
    Accent = "accent",
    Ghost = "ghost",
    Success = "success",
    Warning = "warning",
    Info = "info",
    Error = "error",
}

